import './UserBox.css';
import { Box, Button, TextField } from "@mui/material";
import { useState, useEffect } from "react";
import { updateUserData } from '../../services/posUsers';

function displayThisSection(displayThis) {
    if (displayThis === 0) {
        return 'block';
    } else {
        return 'none';
    }
}

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const UserBox = (props) => {
    const userData = props.user || {};

    const displaySection = displayThisSection(props.displayThis);

    const [editMode, setEditMode] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        address: "",
        id: "",
        phone: ""
    });
    const [emailError, setEmailError] = useState(false);

    // Sincronizar formData con userData cuando cambie
    useEffect(() => {
        setFormData({
            name: userData.name || "",
            email: userData.email || "",
            address: userData.address || "",
            id: userData.id || "",
            phone: userData.phone || ""
        });
    }, [userData]);

    const handleEdit = () => setEditMode(true);

    const handleCancel = () => {
        setFormData({
            name: userData.name || "",
            email: userData.email || "",
            address: userData.address || "",
            id: userData.id || "",
            phone: userData.phone || ""
        });
        setEmailError(false);
        setEditMode(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if (name === "email") {
            setEmailError(!emailRegex.test(value));
        }
    };

    const isDisabled =
        emailError ||
        (
            formData.name === userData.name &&
            formData.email === userData.email &&
            formData.phone === userData.phone &&
            formData.address === userData.address
        );

    const handleSave = async () => {
        if (emailError) return;

        try {
            const updatedUser = await updateUserData({
                id: formData.id,
                name: formData.name,
                email: formData.email,
                phone: formData.phone,
                address: formData.address,
            });
            console.log("Usuario actualizado:", updatedUser);

            const updated = {
                ...userData,
                ...formData
            };
            localStorage.setItem('user', JSON.stringify(updated));
            props.setUser?.(updated);
            setEditMode(false);
            alert("Usuario actualizado correctamente.");
        } catch (error) {
            alert("Error al actualizar usuario.");
        }
    };

    return (
        <Box className="data-block" style={{ display: displaySection }}>
            <div className="acc-info">
                <div>
                    <div style={{ fontWeight: 'bold' }}>Nombre de usuario:</div>
                    {editMode ? (
                        <TextField
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            size="small"
                            fullWidth
                            variant="filled"
                            className='input-editarusuario'
                        />
                    ) : (
                        userData.name || "No disponible"
                    )}
                </div>
                <div>
                    <div style={{ fontWeight: 'bold' }}>Correo:</div>
                    {editMode ? (
                        <TextField
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            error={emailError}
                            helperText={emailError ? "Correo inválido" : ""}
                            size="small"
                            fullWidth
                            variant="filled"
                            className='input-editarusuario'

                        />
                    ) : (
                        userData.email || "No disponible"
                    )}
                </div>
                <div>
                    <div style={{ fontWeight: 'bold', wordBreak: 'break-word' }}>Dirección de envío:</div>
                    {editMode ? (
                        <TextField
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                            size="small"
                            fullWidth
                            variant="filled"
                            className='input-editarusuario'

                        />
                    ) : (
                        userData.address || "No disponible"
                    )}
                </div>
                <div>
                    <div style={{ fontWeight: 'bold' }}>Teléfono:</div>
                    {editMode ? (
                        <TextField
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            size="small"
                            fullWidth
                            variant="filled"
                            className='input-editarusuario'

                        />
                    ) : (
                        userData.phone || "No disponible"
                    )}
                </div>
                <div>
                    <div style={{ fontWeight: 'bold' }}>Id de Volteon:</div>
                    {editMode ? (
                        <TextField
                            name="id"
                            value={formData.id}
                            onChange={handleChange}
                            size="small"
                            fullWidth
                            variant="filled"
                            disabled
                            className='input-editarusuario'

                        />
                    ) : (
                        userData.id || "No disponible"
                    )}
                </div>
            </div>
            <div className="button-group">
                {!editMode ? (
                    <Button
                        variant="contained"
                        className="boton-editar-editarusuario"
                        onClick={handleEdit}
                    >
                        Editar
                    </Button>
                ) : (
                    <>
                        <Button
                            variant="outlined"
                            className="boton-cancelar-editarusuario"
                            onClick={handleCancel}
                        >
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            className="boton-guardar-editarusuario"
                            onClick={handleSave}
                            disabled={isDisabled}
                            style={{
                                backgroundColor: isDisabled ? '#888' : undefined,
                                color: isDisabled ? '#ccc' : undefined,
                                cursor: isDisabled ? 'not-allowed' : 'pointer',
                                opacity: isDisabled ? 0.7 : 1
                            }}
                        >
                            Guardar
                        </Button>
                    </>
                )}
            </div>

        </Box>
    );
};

export default UserBox;